import { io } from "socket.io-client";
import { store } from "../../store";
import { addMessage, updateConversation, addConversation } from "../../slices/messagesSlice";
import { logError } from "../../utils/errorDispatchers";
import { getUserCoordinates } from '../../utils/geolocation';

const socket = io(process.env.REACT_APP_SERVER_URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 3000,
});

// 🟢 Join `joinArea` on app initialization (applies to all users)
socket.on("connect", async () => {
  console.log("✅ Connected to socket server:", socket.id);
  try {
    const result = await getUserCoordinates();
    const coordinates = result?.coordinates;
    if (coordinates) {
      console.log(`📍 Joining area with coordinates: ${coordinates}`);
      socket.emit("joinArea", coordinates);
    }
  } catch (error) {
    console.error("❌ Failed to get user coordinates:", error);
  }
});

// 🟢 Function to join `joinUser` (called after login)
export const emitJoinUser = () => {
  const user = store.getState().auth.user;
  if (user && user._id) {
    console.log(`🟢 Emitting joinUser for user: ${user._id}`);
    socket.emit("joinUser", user._id);
  } else {
    console.warn("⚠️ No user found in store, joinUser not emitted!");
  }
};

socket.on("newMessage", (message) => {
  const currentUser = store.getState().auth.user;
  if (currentUser && message.senderId === currentUser._id) return;
  store.dispatch(addMessage({ conversationId: message.conversationId, message }));
});

socket.on("updateConversation", (conversation) => {
  store.dispatch(updateConversation(conversation));
});

socket.on("newConversation", (conversation) => {
  store.dispatch(addConversation(conversation));
});

socket.on("messageError", (payload = {}) => {
  const message =
    payload.message || "Message could not be delivered.";
  logError(store.dispatch, {
    type: "TOAST",
    severity: "warning",
    message,
    component: "socketClient:messageError",
  });
});

socket.on("conversationError", (payload = {}) => {
  const message =
    payload.message || "Could not start conversation.";
  logError(store.dispatch, {
    type: "TOAST",
    severity: "warning",
    message,
    component: "socketClient:conversationError",
  });
});

export default socket;